<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">General Settings</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>
  <v-row>
    <v-col cols="4">
      <v-data-table
        disable-pagination
        hide-default-footer
        :height="336"
        :headers="headers"
        :fixed-header="true"
        :items="allInvalidPasswords"
        :search="search"
        class="elevation-12 mt-2"
        @current-items="getFiltered"
      >

        <template v-slot:top >
          <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
            <v-toolbar dense flat color="#DBEFFA">
              <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Add Invalid Password</v-toolbar-title>
              <v-spacer/>
            </v-toolbar>
            <v-container>
              <v-text-field
                class="mb-0"
                light dense filled
                color="#2A353D"
                v-model="NewPassword.Password"
                label="Password"
                required
                :rules="TextFieldRules"
              ></v-text-field>

              <div class="text-right">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
              </div>                 
            </v-container>
            <v-divider class="mt-0"/>
          </v-form>
  
          <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit">
            <v-toolbar dense flat color="#DBEFFA">
              <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Edit Password</v-toolbar-title>
              <v-spacer/>
            </v-toolbar>
            <v-container>
              <v-text-field
                light dense filled
                color="#2A353D"
                v-model="currentPassword.Password"
                label="Password"
                required
                :rules="TextFieldRules"
              ></v-text-field>

              <div class="text-right mt-7">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="closeEdit()">close</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" @click="updatePassword()">save</v-btn>
              </div>
            </v-container>
            <v-divider class="mt-0"/>
          </v-form>

          <v-container row>
            <v-spacer/>
            <v-btn v-if="showCreateBtn == true" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
              Create New<v-icon small>mdi-plus</v-icon>
            </v-btn>
            <!-- <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
                EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
              </v-btn>
              </template>
              <v-list dense>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </v-btn>
              </v-list-item>
              </v-list>
            </v-menu>
            <v-btn outlined small color="#2A353D" class="ml-2" v-on="on">
              PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
            </v-btn> -->
          </v-container>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn
            small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
            @click="setActivePassword(item, index); showEdit(); closeCreate()"
            color="#2A353D" class="mr-3"
          >
            <span>edit</span>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="8">
      <v-card elevation="12" class="mt-2">
      <v-form class="edit rounded-t-xl" ref="form2" v-model="valid2" lazy-validation>
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Settings</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].PasswordHistory"
            label="Password history:"
            suffix="months"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].LockAccountIfInactive"
            label="Lock account if inactive for:"
            suffix="days"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].AccountLockoutThreshold"
            label="Account lockout threshold"
            suffix="attempts"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-checkbox
            v-model="Settings[0].PermitConcurrentLogins"
            class="mt-0"
            label="Permit concurrent logins?"
          ></v-checkbox>
        </v-col>
        <v-col>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].TimeoutAfter"
            label="Timeout in:"
            suffix="minutes"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].AccountLockoutDuration"
            label="Account lockout duration"
            suffix="minutes"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-text-field
            light dense filled
            color="#2A353D"
            v-model="Settings[0].MaximumPasswordAge"
            label="Maximum password age"
            suffix="days"
            required
            :rules="TextFieldRules"
          ></v-text-field>
          <v-checkbox
            v-model="Settings[0].PermitStrongPasswordOnly"
            class="mt-0"
            label="Permit strong passwords only?"
          ></v-checkbox>
          <div class="text-right">
            <v-btn class="white--text" small color="#2A353D" :disabled="!valid2" @click="updateGeneralSettings()">save</v-btn>          
          </div>
        </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';

export default {
  name: 'general_setttings',

  data () {
    return {
      edit: false,
      create:false,
      permitted: null,
      permitted_dialog: true,
      message: '',
      search: '',
      valid: true,
      valid2: true,
      content: '',
      currentPassword: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Red Flagged Passwords',
          align: 'start',
          sortable: true,
          value: 'Password'
        },
        {align: 'end', value: 'actions', sortable: false}
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      NewPassword: {},
    }
  },

  computed: {
    ...mapGetters([
      "Settings",
      "allInvalidPasswords",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 503).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 503).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 503).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 503).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 503).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  methods: {
    ...mapActions([
      "createInvalidPassword",
      "updateInvalidPasswords",
      "updateSettings"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.createInvalidPassword(this.NewPassword)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newPassword',
            data: response.data
          });
          this.message = response.data.message
          this.reset()
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    async updateGeneralSettings() {
      this.message = '';
      await this.validate2();
      if(this.valid2 == true){
        this.Settings[0].LastUserID = this.currentUser.SecurityUserID,

        this.updateSettings(this.Settings[0])
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSettings',
            data: this.Settings[0]
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    async updatePassword() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.updateInvalidPasswords(this.currentPassword)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updPassword',
            data: this.currentPassword
          });
          
          this.message = response.data.message
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.create = false
      this.reset()
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    validate2 () {
      this.$refs.form2.validate()
    },

    reset2 () {
      this.$refs.form2.reset()
    },

    setActivePassword (item, index) {
      this.currentPassword = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isGeneralSecurity().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
